import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type EditIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const EditIcon = ({
  title = 'Pencil',
  viewBox = '0 0 24 24',
  ...props
}: EditIconProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props} fill="none">
    <path
      d="M4 20H8L18.5 9.5C19.6046 8.39543 19.6046 6.60457 18.5 5.5C17.3954 4.39543 15.6046 4.39543 14.5 5.5L4 16V20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 6.5L17.5 10.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);

export default EditIcon;
